import { Container, ProgressBar } from 'react-bootstrap'

import {
  isMtBackofficeStore,
  motorTradeFormStore,
} from '@/store/MotorTradeFormStore'
import CG_Logo from '@/assets/images/cg_logo.png'

import { BrokerRibbon } from './BrokerRibbon'
import { MTBackOfficeRibbon } from './MTBackofficeRibbon'

const Header = () => {
  const { step, formData } = motorTradeFormStore()
  const { backoffice } = isMtBackofficeStore()

  const totalNumberOfSteps =
    (formData?.coverLevelID === 1 || formData?.coverLevelID === 3) &&
    formData?.coverIndemnityLimitOwnVehiclesID <= 6 &&
    step > 8
      ? 13
      : 14

  return (
    <>
      <Container bsPrefix="container-fluid">
        <div className="d-flex align-items-center mt-3">
          <div className="logo">
            <img src={CG_Logo} alt="CG logo" />
          </div>
        </div>
      </Container>
      <div className="mt-3">
        {backoffice ? <MTBackOfficeRibbon /> : <BrokerRibbon />}

        <div className="mb-2">
          <ProgressBar
            now={Math.round((step / totalNumberOfSteps) * 100)}
            className="mx-n3 mx-sm-0"
          />
        </div>
      </div>
    </>
  )
}

export default Header
